import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { sortBy } from 'es-toolkit/compat';
import { Formik } from 'formik';

import { OrderStatusModel } from '@merchant-clients/order';

import { DialogForm } from '@frontend/components';
import { tCommon, tOrder } from '@frontend/locales/t.generated';
import { toFormPlaceIds, toPersistedPlaceIds } from '@frontend/utils';

import { OrderFilterContent } from './order-filter-content.component';
import { OrderFilterInput } from './order-filter-input.interface';

const statuses: OrderStatusModel[] = [
  'PENDING',
  'CONFIRMED',
  'READY',
  'CLOSED',
  'REFUNDED',
  'REJECTED',
];
export interface FilterDialogProps {
  initialValues: OrderFilterInput;
  open: boolean;
  onClose(): void;
  onSubmit?(input: OrderFilterInput): void;
}

export const FilterDialog = (props: FilterDialogProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            maxWidth: '90vw',
            width: 720,
          },
        },
      }}
    >
      {props.open && props.initialValues && (
        <Formik<OrderFilterInput>
          initialValues={{
            ...props.initialValues,
            status: statuses.every((s) =>
              props.initialValues.status.includes(s as OrderStatusModel),
            )
              ? ['ALL']
              : props.initialValues.status,
            placeIds: toFormPlaceIds(props.initialValues.placeIds),
            period: props.initialValues.period || 'TODAY',
          }}
          onSubmit={(values) => {
            props.onSubmit?.({
              ...values,
              placeIds: toPersistedPlaceIds(values.placeIds),
              status:
                values.status[0] === 'ALL'
                  ? statuses
                  : sortBy(values.status as OrderStatusModel[], (status) =>
                      statuses.indexOf(status),
                    ),
            });
            props.onClose();
          }}
        >
          {(formikProps) => {
            return (
              <DialogForm>
                <DialogTitle>{tOrder.headers.filter()}</DialogTitle>

                <DialogContent>
                  <OrderFilterContent />
                </DialogContent>

                <DialogActions>
                  <Button
                    variant="outlined"
                    color="neutral"
                    sx={{ minWidth: 128 }}
                    onClick={() => {
                      props.onClose();
                    }}
                  >
                    {tCommon.actions.back()}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    sx={{ minWidth: 128 }}
                    disabled={!formikProps.isValid || !formikProps.dirty}
                  >
                    {tCommon.actions.save()}
                  </Button>
                </DialogActions>
              </DialogForm>
            );
          }}
        </Formik>
      )}
    </Dialog>
  );
};
